const portfolioObjects = [
	{
		img:"./assets/img/erobu-dungeon.png",
		title:"Erobu's Dungeon",
		description:"Built with Javascript and an emphasis on JQuery, Erobu's Dungeon is a turn-taking Deep-Dungeon RPG that will allow you to use abilities and keep going until you run out of health and die. This was the first project that I worked on and displays my early deep understanding of Javascript.",
		urlDemo:"https://shawhien.github.io/erobus-dungeon/",
		urlCode:"https://github.com/shawhien/erobus-dungeon",
		details:["Javascript","JQuery","HTML","CSS","Heroku","Animation","Mobile"],
	},
	{
		img:"./assets/img/giveback.png",
		title:"GiveBack",
		description:"GiveBack was built with a team of developers with a full MERN stack. We were able to build an app to allow people to give back to their communities by volunteering featuring the React Calendar. Upon login, Users can find events posted by local organizations that they can sign up for.",
		urlDemo:"https://givebackvolunteer.herokuapp.com/",
		urlCode:"https://github.com/shawhien/giveback",
		details:["React.js","MongoDB","Mongoose","Materialize UI", "Nodejs","Express"],
	},
	{
		img:"./assets/img/seitonyn.png",
		title:"Seitonyn",
		description:"Built using Unity and C#, Seitonyn is an open world action RPG game which allows you to control your character and help the local town rid them of those pesky bandits that keep bothering them. This is a project that I'm going to continue to work on and improve whenever I have free time.",
		urlDemo:"",
		urlCode:"https://github.com/shawhien/seitonyn",
		details:["C#","Unity","Sandbox","Animation","Scripts","Deployment"],
	},
	{
		img:"./assets/img/fetch.png",
		title:"Fetch",
		description:"Placed in the top 3 overall, and 1st for presentation, Fetch was built in 24 hours for a Hackathon working alongside UX/UI Designers featuring an AI chatbot. Find your perfect match by looking at pictures of people's dogs and reading information about their Hooman.",
		urlDemo:"",
		urlCode:"https://github.com/shawhien/fetch-hackathon",
		details:["React.js","Javascript","Materialize UI","AI Chatbot"],
	},
	// {
	// 	img:"./assets/img/showstopper.png",
	// 	title:"Showstopper",
	// 	description:"Utilizing SQL/Sequelize and Javascript, Showstopper allows you to keep track of concerts happening in your area. You can sign up for an account have your own personalized dashbord based on your taste in music! You can for your favorite bands or songs, check to see if they are touring, and add them to your favorites list if they are so you won't miss that show!",
	// 	urlDemo:"",
	// 	urlCode:"https://github.com/shawhien/showstopper",
	// 	details:["SQL","Sequelize","Javascript","Nodejs","Express","Authentication","ORM"],
	// }
]

module.exports = portfolioObjects;


// WEBPACK FOOTER //
// ./src/utils/portfolioObjects.js